module.exports = __webpack_public_path__ + "static/media/1002938.d6e10688.png";